import { contentGet } from '../../../../shared/email-activity/content-api'

// The Request log read API (rapid-api-content, audit-trail spec §4.7), gated
// by SYS_REQUEST_LOG. Each resolves to the body; a refusal throws the
// response ({ status, data: { message, code } }), so serverMessage(err)
// shows the server's own sentence (e.g. the 503 "narrow your search").
export const listRequests = params => contentGet('audit/requests', params)
// at (RFC 3339, when the request ran: an error occurrence's or an audit
// entry's time) bounds the lookup to a day either side; without it the
// whole log is searched.
export const getRequest = (requestID, at) => contentGet(`audit/requests/${encodeURIComponent(requestID)}`, { at })
export const slowRoutes = params => contentGet('audit/requests/routes', params)
